<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="!pickerPane && !previewPane" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="true">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="ma-3">
            </SupplierSelect>

            <v-row no-gutters justify="start" align="center" class="ma-3">
              <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.article.techniciansparepart") }}:</p>
              <TechnicianSparePartFilter :pk="pk"></TechnicianSparePartFilter>
            </v-row>

            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getCommonPartsFromFilter" :locked-filters="lockedFilters" :optional-filters="filters"
          :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="25"
          :itemValueKey="'ArticleId'" ref="ListPane" :open-function="openItem" :pk="pk">

          <template v-slot:list-item="{ item, index }">
            <draggable tag="div" :data-index="index" class="ignoreodd" :id="domIdKey + item.SortOrder" handle=".handle"
              :setData="removeDragImage" v-bind="dragOptions" @end="dragend">
              <v-row :key="item.Id" :id="articleDomIdKey + item.ArticleId" no-gutters align="stretch"
                class="flex-nowrap" style="border-bottom: 1px solid var(--v-disabled-base);">
                <v-col cols="auto" :class="!item.removeLoading ? 'handle hovercol' : ''"
                  class=" d-flex align-center justify-center px-3"
                  :style="item.removeLoading ? 'opacity: 0;' : 'opacity: 1;'" @click.stop="">
                  <div>
                    <v-icon size="20">
                      mdi-drag-horizontal-variant
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="0" style="max-width: calc(100% - 132px);">
                  <ListItem :item="item.Article" :showStoreItems="false" class="px-1" @click="openItem(item)" />
                </v-col>
                <v-col v-if="previewPane != item.Article.ArticleNumber" cols="auto"
                  class="hovercol d-flex align-center justify-center px-3" @click.stop="openPreview(item)">
                  <v-icon size="20">
                    mdi-view-split-vertical
                  </v-icon>
                </v-col>
                <v-spacer v-else></v-spacer>
                <v-hover v-slot="{ hover }">
                  <v-col cols="auto" class="hovercol2 d-flex align-center justify-center px-3"
                    @click.stop="item.removeLoading ? undefined : remove(item)">
                    <v-icon v-if="!item.removeLoading" size="20" v-text="hover ? 'mdi-delete-empty' : 'mdi-delete'">
                    </v-icon>
                    <v-progress-circular v-else indeterminate size="20" width="2" color="primary">
                    </v-progress-circular>
                  </v-col>
                </v-hover>
              </v-row>
            </draggable>
          </template>

        </ListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane v-if="!pickerPane" :articleNumber="previewPane" :closePreviewFunc="closePreview">
        </PreviewPane>
        <ArticlePickerPane v-else :locked-filters="lockedPickerFilters" multiple :showQuickFilters="false"
          @select="selectionFilter => select(selectionFilter)">
        </ArticlePickerPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import Vue from "vue";
import draggable from "vuedraggable";
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/ArticleListItem2.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import PreviewPane from "@/components/Sections/Panes/PreviewArticle.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ArticlePickerPane from "../articles/ArticlePickerPane.vue";
import TechnicianSparePartFilter from "@/components/TechnicianSparePartFilter.vue";

export default {
  name: "ViewMachineModelCommonParts",
  props: {},
  components: {
    PreviewPane,
    Layout,
    ListItem,
    FilterPane,
    ListPane,
    SupplierSelect,
    DefaultLifeCycleFilterGroup,
    ArticlePickerPane,
    draggable,
    TechnicianSparePartFilter,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "MMCPL-",
      domIdKey: 'commonpart-',
      articleDomIdKey: 'article-',
    };
  },

  methods: {
    removeDragImage(x/*,y*/) {
      let img = new Image();
      img.src = "";
      x.setDragImage(img, 0, 0);
    },

    dragend(event) {
      //console.log("dragend", event);
      const divId = event.to.id;
      if (divId && divId.includes(this.domIdKey)) {
        var split = divId.split(this.domIdKey);
        const target = split[1];
        const articleId = event.item.id.split(this.articleDomIdKey)[1];
        //console.log("new index", target, articleId);
        this.move(articleId, target);
      }
    },

    async move(articleId, targetIndex) {
      return await this.changeCommonPartPosition(this.modelId, articleId, targetIndex);
    },

    remove(item) {
      Vue.set(item, 'removeLoading', true);
      this.removeCommonPartFromModel(this.modelId, item.Article.Id)
        .then(() => {
          Vue.set(item, 'removeLoading', false);
          this.$refs.ListPane.handleremoved(item);
        });
    },

    async select(selectionFilter) {
      await this.addCommonPartsToModel(this.modelId, selectionFilter);
      this.$refs.ListPane.fetch();
    },

    openPicker() {
      this.pickerPane = 'article';
    },
    closePicker() {
      this.pickerPane = undefined;
    },

    openPreview(item) {
      if (this.pickerPane) {
        this.closePicker();
      }
      this.previewPane = item.Article.ArticleNumber;
    },
    closePreview() {
      this.previewPane = undefined;
    },

    openItem(item) {
      //console.log('openItem', item);
      var article = item.Article;
      this.$router.push({ name: 'ViewArticle', params: { articleId: article.Id, articleNumber: article.ArticleNumber } })
    },

    handleadded(item) { this.$refs.ListPane.handleadded(item) },
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),
  },

  computed: {
    modelId() {
      return this.$route.params.modelId;
    },

    PreviewCustomer() { return this.$store.getters["JobHub/JobPreview/PreviewCustomer"]; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes("filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          SupplierIdList: this.suppliersfilter,
          IsTechnicianPart: this.getQueryParam("filter-technicianpart", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    lockedFilters() {
      return { CommonPartFromMachineModelIdList: [this.modelId] };
    },

    lockedPickerFilters() {
      return { ExcludeCommonPartsFromModelIdList: [this.modelId] };
    },

    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },

    pickerPane: {
      get() {
        return this.$route.query.picker;
      },
      set(update) {
        this.$router.replace({ params: this.$route.params, query: { ...this.$route.query, picker: update } });
      },
    },

    previewPane: {
      get() {
        return this.$route.query.preview;
      },
      set(update) {
        this.$router.push({ query: { ...this.$route.query, preview: update } });
      },
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  watch: {},
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.handle {
  cursor: ns-resize;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 1;
  border: 2px solid var(--v-primary-base) !important;
}
</style>